import api from './api';
import { Employee, Department } from '../types';

export const employeeService = {
  async getAll(): Promise<Employee[]> {
    const response = await api.get<Employee[]>('/employees');
    return response.data;
  },

  async getById(id: number): Promise<Employee> {
    const response = await api.get<Employee>(`/employees/${id}`);
    return response.data;
  },

  async create(employee: Partial<Employee>): Promise<Employee> {
    const response = await api.post<Employee>('/employees', employee);
    return response.data;
  },

  async update(id: number, employee: Partial<Employee>): Promise<void> {
    await api.put(`/employees/${id}`, employee);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/employees/${id}`);
  },

  async getDepartments(): Promise<Department[]> {
    const response = await api.get<Department[]>('/departments');
    return response.data;
  },
};
